import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { EnvGet } from '../../utils/EnvGet';
import BankingTypeContext from '../../utils/BankingType/context';
import CategoryDemoContext from '../../utils/CategoryDemo/context';
import { BlobParam } from '../../utils/SiteTools';
import { LobConditional, lobDemoSplit } from "../../utils/LobLogicModule";

import { adaTabs } from '../../utils/adaTabs';

import { tabControl } from './data/tabControl.json';
import * as SELECTORS from '../../constants/selectors';
import './TabControl.scss';

/**
 * Tab Control component
 * Manages the Tab Control and shown demo list
 * @param selectorKey - The name of the Page to know wich content should be shown
 */

const TabControl = ({ selectorKey, content, categoryId }) => {
    
    const { t } = useTranslation('tabControl');
    const [demoItems, setDemoItems] = useState(null);
    const { bankingType, setBankingType } = useContext(BankingTypeContext);
    const { categoryDemoData } = useContext(CategoryDemoContext);
    const sourceName = EnvGet();
    
    let demoType = (bankingType === SELECTORS.OLB) ? SELECTORS.ONLINE_DEMO : (bankingType === SELECTORS.MB) ? SELECTORS.MOBILE_DEMO : (bankingType === SELECTORS.MPOS) ? SELECTORS.MPOS_DEMO : (bankingType === SELECTORS.ESSENTIALS) ? SELECTORS.ESSENTIALS_DEMO : '';
    const bankingDemo = bankingType === SELECTORS.OLB ? 'OnlineBanking' : SELECTORS.MB ? 'MobileBanking' : SELECTORS.MPOS ? 'MposBanking' : 'EssentialsBanking';
    const isMobileDemos = (selectorKey !== 'home' && demoItems) && demoItems[0].submenu[SELECTORS.MOBILE_DEMO].length ? true : false;
    const isOnlineDemos = (selectorKey !== 'home' && demoItems) && demoItems[0].submenu[SELECTORS.ONLINE_DEMO].length ? true : false;
    const isMposDemos = (selectorKey !== 'home' && demoItems) && demoItems[0].submenu[SELECTORS.MPOS_DEMO].length ? true : false;
    const isEssentialsDemos = (selectorKey !== 'home' && demoItems) && demoItems[0].submenu[SELECTORS.ESSENTIALS_DEMO].length ? true : false;
    const { search } = useLocation();
    
    useEffect(() => {
        if(lobDemoSplit !== '/sb') {
            setBankingType('mb');
        } else {
            const pageUrl = window.location.href;
            pageUrl.match(`/merchantservices`) ? setBankingType('olb') : setBankingType('olb')
        }
        // View was not rendering sometimies due to delay in State uupdate so to fix it I added little delay
        adaTabs();
        const tempArray = categoryDemoData.filter(category => category.path === categoryId);
        let waitmer = function() { //this is a timer or interval with timeout to check if the object exist
            setTimeout(function () {
                if(tempArray[0] !== undefined) { //this to avoid issue with homepage
                    if(tempArray[0].submenu.mobileDemo === null) { //to check that we have values from header object construction
                        waitmer();
                      } else {
                        setDemoItems(tempArray);
                      }
                }
            }, 300);
          };
          waitmer();

    }, [categoryDemoData, categoryId, setBankingType]);
    
    const changeBankingType = e => {
        const type = e.target.id;
        setBankingType(type);
        setTimeout( () => window.bactm.rescanDOM() , 100);
    }

    return (
        <div className={`tab-control-wrapper container_wrapper${(selectorKey !== 'home' && (!isMobileDemos && !isOnlineDemos && !isMposDemos && !isEssentialsDemos)) ? ' hide' : ''}`}>
            <div id="tab-control" className={`tab-control${selectorKey === 'home' ? ' tab-control--text' : ' tab-control--list'}`} data-action="tab-control">
                {
                    selectorKey === 'home'
                        ?   <div className="power-copy" dangerouslySetInnerHTML={{ __html: content }}></div>
                        :   <ul className="type-list" role="tablist" aria-label={t(tabControl.tabListLabel)}>
                            {
                                tabControl.typeList.map(item => <li key={item.id} className={`type-item${bankingType === item.id ? ' selected' : ''}${((((item.id === SELECTORS.MB && !isMobileDemos) || (item.id === SELECTORS.OLB && !isOnlineDemos )))) ||  ((((item.id === SELECTORS.MPOS) || (item.id === SELECTORS.ESSENTIALS)) && (!isMposDemos || !isEssentialsDemos))) ? ' hide' : ''}`}><button id={item.id} data-component="Tab" className="btn t-track-custom" onClick={changeBankingType} dangerouslySetInnerHTML={{ __html: t(item.label) }} role="tab" aria-selected={bankingType === item.id ? true  : false} aria-controls={`${item.id}-tab`} tabIndex={`${bankingType !== item.id ? '-1': '0'}`} data-bactmln={`Navigation-_-Click-_-${item.id}Tab`}></button></li>)
                            }
                            </ul>
                }
            </div>
            { selectorKey !== 'home' &&
                <div className="demo-list-wrapper">
                    <ul className="demo-list-items" id={`${bankingType}-tab`} tabIndex="0" role="tabpanel" aria-labelledby={bankingType}>
                    {
                        
                        ((demoItems && !demoItems[0].submenu['mobileDemo'].length ? 'onlineDemo' : 'mobileDemo' ) || (demoItems && demoItems[0].submenu['mposDemo'].length ? 'mposDemo' : 'essentialsDemo' )) && (demoItems && demoItems[0].submenu[demoType]) && demoItems[0].submenu[demoType].map((demoItem, i) => (
                            <li key={i} className="demo-item">
                                <Link id={demoItem.path} data-component={bankingDemo} to={demoItem.path+BlobParam(search)} className="demo-link t-track-cta" data-bactmln={ LobConditional ? 'Body-_-CTA-_-'+demoItem.path : bankingDemo+"-_-CTA-_-"+demoItem.path}>
                                    <img aria-hidden="true" focusable="false" className="demo-icon" src={`${sourceName}${demoItem.icon}`} alt={demoItem.title} />
                                    <span className="demo-link--text">{demoItem.title}</span>
                                </Link>
                            </li>
                        ))
                    }
                        <li className="demo-item no-items" dangerouslySetInnerHTML={{ __html: t(tabControl.no_demo_items) }}></li>
                    </ul>
                </div>
            }
        </div>
    );
};

export default TabControl;